import * as z from 'zod';

/**
 * A map coordinate, in the old panel's `{long, lat}` field order.
 *
 * This lives here rather than in a consuming slice because BOTH the order
 * draft and the branch form speak it, and FSD forbids one entity importing
 * another — so the type has to sit with the geocoding that produces it.
 */
export const legacyPointSchema = z.object({
  long: z.number(),
  lat: z.number(),
});

export type LegacyPoint = z.infer<typeof legacyPointSchema>;
